import React, { useState } from "react";

const BlogImage = ({ blogData }) => {
  const [loading, setLoading] = useState(true);

  if (!blogData) return null;

  return (
    <div className="py-6 px-4 md:px-10">
      {/* Skeleton Loader */}
      {loading && (
        <div className="w-full h-60 md:h-80 bg-gray-300 animate-pulse rounded-lg" />
      )}

      {/* Actual Image */}
      <img
        src={blogData.image}
        alt={blogData.title}
        onLoad={() => setLoading(false)}
        className={`w-full max-h-80 object-cover rounded-lg transition-opacity duration-500 ${
          loading ? "opacity-0" : "opacity-100"
        }`}
      />
    </div>
  );
};

export default BlogImage;
